import { fetchAuthSession, signInWithRedirect } from 'aws-amplify/auth'

const fetchCognitoToken = async () => {
  const session = await fetchAuthSession()

  if (!session?.tokens?.idToken) {
    await signInWithRedirect({ provider: { custom: 'AzureB2C' } })
  }

  return session.tokens?.idToken
}

export default fetchCognitoToken
